var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 84,
    height: 84
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5415 24.5C26.5415 26.666 27.4019 28.7432 28.9335 30.2747C30.465 31.8063 32.5422 32.6667 34.7082 32.6667C36.8741 32.6667 38.9513 31.8063 40.4829 30.2747C42.0144 28.7432 42.8748 26.666 42.8748 24.5C42.8748 22.3341 42.0144 20.2569 40.4829 18.7253C38.9513 17.1938 36.8741 16.3334 34.7082 16.3334C32.5422 16.3334 30.465 17.1938 28.9335 18.7253C27.4019 20.2569 26.5415 22.3341 26.5415 24.5ZM63.2915 49C63.2915 51.166 64.1519 53.2432 65.6835 54.7747C67.215 56.3063 69.2922 57.1667 71.4582 57.1667C73.6241 57.1667 75.7013 56.3063 77.2329 54.7747C78.7644 53.2432 79.6248 51.166 79.6248 49C79.6248 46.8341 78.7644 44.7569 77.2329 43.2253C75.7013 41.6938 73.6241 40.8334 71.4582 40.8334C69.2922 40.8334 67.215 41.6938 65.6835 43.2253C64.1519 44.7569 63.2915 46.8341 63.2915 49ZM26.5415 73.5C26.5415 75.666 27.4019 77.7432 28.9335 79.2747C30.465 80.8063 32.5422 81.6667 34.7082 81.6667C36.8741 81.6667 38.9513 80.8063 40.4829 79.2747C42.0144 77.7432 42.8748 75.666 42.8748 73.5C42.8748 71.3341 42.0144 69.2569 40.4829 67.7253C38.9513 66.1938 36.8741 65.3334 34.7082 65.3334C32.5422 65.3334 30.465 66.1938 28.9335 67.7253C27.4019 69.2569 26.5415 71.3341 26.5415 73.5Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 73.5H26.5415M42.8748 73.5H89.8332M8.1665 24.5H26.5415M42.8748 24.5H89.8332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 8.16669V89.8333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 49H63.2915M79.6248 49H89.8332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H98V98H0V0Z",
    fill: "#B4BBC1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.d7a5cdc08508d29a77843cfaae7236cc.svg";
export { ForwardRef as ReactComponent };